import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const build = (names) => (names.length ? new RegExp(`\\b(${names.map(escapeRe).join("|")})\\b`, "gi") : null);
const find = (re, texts) => {
  if (!re) return [];
  const found = new Map();
  for (const t of texts) for (const m of (t || "").matchAll(re)) found.set(m[0].toLowerCase(), m[0]);
  return [...found.values()];
};

export const useBannedTerms = (...texts) => {
  const [terms, setTerms] = useState({ sportsbooks: [], profanity: [] });
  useEffect(() => { api.get("/portal/banned-terms").then((r) => setTerms({ sportsbooks: r.data.sportsbooks || [], profanity: r.data.profanity || [] })).catch(() => {}); }, []);
  const bookRe = useMemo(() => build(terms.sportsbooks), [terms.sportsbooks]);
  const curseRe = useMemo(() => build(terms.profanity), [terms.profanity]);
  const joined = texts.join("\n");
  return useMemo(() => ({ sportsbooks: find(bookRe, [joined]), profanity: find(curseRe, [joined]) }), [bookRe, curseRe, joined]);
};
